import { Building2, Shield, CheckCircle } from "lucide-react";

export default function ProviderSection() {
  return (
    <section
      data-testid="provider-section"
      className="py-16 md:py-20 bg-white border-y border-gray-100"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center">
          {/* Header */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0F3D56]/10 mb-6">
            <Building2 size={32} className="text-[#0F3D56]" />
          </div>
          
          <h2
            className="text-2xl md:text-3xl font-semibold text-[#111827] mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Proveedor educativo del programa
          </h2>

          {/* Main Content */}
          <div className="bg-gray-50 border border-gray-200 p-8 md:p-10 max-w-2xl mx-auto">
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              El programa educativo referido en esta página es provisto por <span className="font-bold text-[#0F3D56]">MINED</span>. 
              DSA participa como embajador y canal de orientación, precalificación y acompañamiento comercial 
              para ayudarte a entender la propuesta y evaluar si encaja contigo.
            </p>

            {/* Roles Clarification */}
            <div className="grid sm:grid-cols-2 gap-4 mt-8">
              <div className="flex items-start gap-3 text-left">
                <div className="w-8 h-8 bg-[#0F3D56] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <CheckCircle size={16} className="text-white" />
                </div>
                <div>
                  <p className="text-sm font-bold text-[#111827]">MINED</p>
                  <p className="text-xs text-gray-500">Proveedor educativo del programa</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-left">
                <div className="w-8 h-8 bg-[#D4C4A8] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Shield size={16} className="text-[#0A1628]" />
                </div>
                <div>
                  <p className="text-sm font-bold text-[#111827]">DSA</p>
                  <p className="text-xs text-gray-500">Embajador y canal de orientación comercial</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
